import { Block } from "@components/block";
import { Input } from "@components/input";
import { CustomSelect } from "@components/select";
import { Button } from "@components/button";
import { useBoolState } from "@hooks/use-bool-state";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./withdrawals.module.scss";
import { Config, DoubleText, Table } from "@components/table";
import { AdminWithdrawalModal } from "@components/admin-withdrawal-modal";
import { useAdminWithdrawals } from "@features/admin/withdrawals";
import {
  AdminWithdrawal,
  AdminWithdrawalsRequest,
} from "@features/admin/withdrawals/api";
import { formatDate, formatTime } from "@helpers/date";
import { usePagination } from "@hooks/use-pagination";
import { useUrlFilters } from "@hooks/useUrlFilters";
import {
  formatUsdt,
  getTronScanAddresUrl,
  getTronScanTxUrl,
} from "@helpers/format";
import { EllipsisText } from "@components/ellipsis-text";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const adminWithdrawalConfig: Config<AdminWithdrawal> = [
  {
    label: "Адрес",
    source: "address",

    renderComponent: (data) => (
      <EllipsisText text={data} copy link={getTronScanAddresUrl(data)} />
    ),
  },
  {
    label: "HASH",
    source: "hash",

    renderComponent: (data) => (
      <EllipsisText text={data} copy link={getTronScanTxUrl(data)} />
    ),
  },
  {
    label: "Email",
    source: "email",
  },
  {
    label: "Роль",
    source: "role",
  },
  {
    label: "Комиссия",
    source: "commission",
    renderComponent: (data) => formatUsdt(data),
  },
  {
    label: "К переводу",
    source: "amount",
    renderComponent: (data) => data + " USDT",
  },
  {
    label: "Списание",
    source: "amount",
    renderComponent: (data, cellData) => data + cellData.commission + " USDT",
  },
  {
    label: "Дата и время",
    source: "created",
    renderComponent: (cellData) => (
      <DoubleText
        text={formatTime(new Date(cellData))}
        subText={formatDate(new Date(cellData))}
      />
    ),
  },
  {
    label: "Статус",
    source: "status",
  },
];

export const AdminWithdrawalsPage = () => {
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [currentWithdrawal, setCurrentWithdrawal] = useState<AdminWithdrawal>();
  const { setParams } = useUrlFilters();
  const { page, limit, setPage, setLimit } = usePagination();
  const { control, handleSubmit } = useForm<AdminWithdrawalsRequest>();

  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Withdrawal) {
      getAdminWithdrawals();
    }
  }, [lastMessage]);

  const onDealClick = (item: AdminWithdrawal) => {
    showModal();
    setCurrentWithdrawal(item);
  };
  const options = [
    { text: "Ожидание", value: "Ожидание" },
    { text: "Выведено", value: "Выведено" },
    { text: "Отменен", value: "Отменен" },
  ];
  const { state, getAdminWithdrawals } = useAdminWithdrawals();

  useEffect(() => {
    getAdminWithdrawals({ limit, page });
  }, [getAdminWithdrawals, limit, page]);

  const search = (data: AdminWithdrawalsRequest) => {
    setParams(data);

    getAdminWithdrawals(data);
  };

  return (
    <Block>
      <div className={styles.filter}>
        <Input
          name="address"
          control={control}
          placeholder="Адрес"
          clearable
        ></Input>
        <Input
          name="user"
          control={control}
          clearable
          placeholder="user ID"
        ></Input>
        <CustomSelect
          name="status"
          control={control}
          options={options}
          placeholder="Статусы"
          clearable
          styles={{ width: "200px" }}
        ></CustomSelect>
        <Button
          className={styles.btn}
          onClick={handleSubmit(search)}
          buttonType="button"
        >
          Search
        </Button>
      </div>
      <Table
        config={adminWithdrawalConfig}
        data={state.withdrawals}
        loading={state.loading}
        onRowClick={onDealClick}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        totalCount={state.count}
      ></Table>
      {currentWithdrawal && (
        <AdminWithdrawalModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          data={currentWithdrawal}
        />
      )}
    </Block>
  );
};
